import {useParams} from "react-router-dom";
import * as GroupGameService from "../../api/GroupGameService";
import * as UserService from "../../api/UserService";
import React, {useEffect, useState} from "react";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import pageStyle from "./GameComments.module.css"
import {Form} from "react-bootstrap";
import InstagramWarning from "../InstagramWarning";

function GroupGameComments(props) {

    const params = useParams()
    const [gameState, setGameState] = useState()
    const [player, setPlayer] = useState()
    const [cards, setCards] = useState()
    const [steps, setSteps] = useState([])
    const [gameSuccessfullyFetched, setGameSuccessfullyFetched] = useState(undefined)
    const [hideEmptySteps, setHideEmptySteps] = useState(false)
    const [textFormat, setTextFormat] = useState(false)
    const [tableFormat, setTableFormat] = useState(true)
    const [loggedIn, setLoggedIn] = useState(undefined)

    function resolveDice(step) {
        if (["regular", "no_move_enter", "on_finish_position",
            "no_move_68_check_3x6_rule", "3x6_rule", "on_finish_position"].includes(step.player_move_type)) {
            return step.dice_number
        } else if (step.player_move_type === "arrow") {
            return "стріла"
        } else if (step.player_move_type === "snake") {
            return "змія"
        } else if (step.player_move_type === "hand_move") {
            return "на землю"
        } else {
            return "unknown"
        }
    }

    useEffectOnce(() => {
        pullCards()
    }, []);

    useEffect(() => {
        if (loggedIn === true) {
            callGameState(null)
        }
        else if (loggedIn === false) {
            callGameState(params.player_id)
        }
    }, [loggedIn])

    function pullCards() {
        GroupGameService.getAllMentorCardsByGroupGameId(params.game_id, (state) => {
                state.unshift({
                    title: "Формування запиту"
                })
                setCards(state)
                UserService.verifyLogin(setLoggedIn)
            }
            ,
            () => setGameSuccessfullyFetched(false))
    }

    function callGameState(playerId) {
        GroupGameService.getGroupGame(params.game_id, playerId, (state) => {
            setGameState(state)
            setPlayerState(state)
            setSteps(getPlayerSteps(state))
            setGameSuccessfullyFetched(true)
        }, (response) => {
            if (response.status === 404) {
                setGameSuccessfullyFetched(false)
            } else {
                window.alert("Помилка!")
            }

        })
    }

    function setPlayerState(state) {
        setPlayer(state.players.filter(player => player.id === params.player_id)[0])
    }

    function getPlayerSteps(state) {
        return state.players.filter(player => player.id === params.player_id).map(player => player.steps.reverse())[0]

    }

    function resolveHideEmptySteps() {
        setHideEmptySteps(!hideEmptySteps)
    }

    function resolveTextFormat() {
        setTextFormat(!textFormat)
        setTableFormat(!tableFormat)
    }

    return (
        <>
            <InstagramWarning/>
            <div
                className={pageStyle.commentsOwner}>Коментарі {loggedIn ? "Провідника" : "гравця - " + player?.name}</div>
            <div className={pageStyle.commentsOwner}>
                Якщо те саме посилання відкриє {loggedIn ? "Гравець" : "Провідник"} - відобразяться його коментарі
            </div>
            <Form>
                <Form.Check
                    style={{
                        marginLeft: "12px",
                    }}
                    checked={hideEmptySteps}
                    id={"personal_game"}
                    type="switch"
                    onChange={resolveHideEmptySteps}
                    label={<b>Сховати кроки без коментарів</b>}
                />
            </Form>
            <Form>
                <Form.Check
                    style={{
                        marginLeft: "12px",
                    }}
                    checked={textFormat}
                    id={"personal_game"}
                    type="switch"
                    onChange={resolveTextFormat}
                    label={<b>Як текст</b>}
                />
            </Form>
            <Form>
                <Form.Check
                    style={{
                        marginLeft: "12px",
                    }}
                    checked={tableFormat}
                    id={"personal_game"}
                    type="switch"
                    onChange={resolveTextFormat}
                    label={<b>Як таблиця</b>}
                />
            </Form>
            <div className={pageStyle.head}>
                <div><b>Назва гри:</b> {gameState?.name}</div>
                <div><b>Ім'я гравця:</b> {player?.name}</div>
                <div><b>Запит гравця:</b> {player?.user_request}</div>
                <div><b>Позиція гравця:</b> {player?.current_user_position}</div>
            </div>

            {
                tableFormat &&
                <table className={pageStyle.table}>
                    <tr>
                        <th>З позиції</th>
                        <th>Кубик</th>
                        <th>На позицію</th>
                        <th>Коментар</th>
                    </tr>
                    {
                        steps.map((step) => {
                            if (hideEmptySteps) {
                                if (step?.comments !== "" && step?.type !== "metaphoric_card") {
                                    return (
                                        <tr>
                                            <th>{step?.from_position} - {cards[step?.from_position]?.title}</th>
                                            <th>{resolveDice(step)}</th>
                                            <th>{step?.to_position} - {cards[step?.to_position]?.title}</th>
                                            <th>{step?.comments === "" ? "-" : step?.comments}</th>
                                        </tr>
                                    )
                                }
                            } else {
                                if (step?.type !== "metaphoric_card") {
                                    return (
                                        <tr>
                                            <th>{step?.from_position} - {cards[step?.from_position]?.title}</th>
                                            <th>{resolveDice(step)}</th>
                                            <th>{step?.to_position} - {cards[step?.to_position]?.title}</th>
                                            <th>{step?.comments === "" ? "-" : step?.comments}</th>
                                        </tr>
                                    )
                                }
                            }
                        })
                    }
                </table>
            }
            {
                textFormat &&
                <div>
                    <div>===============================================</div>
                    {
                        steps.map((step) => {
                            if (hideEmptySteps) {
                                if (step?.comments !== "" && step?.type !== "metaphoric_card") {
                                    return (
                                        <div className={pageStyle.freeText}>
                                            <div>[{step?.from_position}:{cards[step?.from_position]?.title} → {resolveDice(step)} → {step?.to_position}:{cards[step?.to_position]?.title}]</div>
                                            <div>{step?.comments === "" ? "-" : step?.comments}</div>
                                            <div>===============================================</div>
                                        </div>
                                    )
                                }
                            } else {
                                if (step?.type !== "metaphoric_card") {
                                    return (
                                        <div className={pageStyle.freeText}>
                                            <div>[{step?.from_position}:{cards[step?.from_position]?.title} → {resolveDice(step)} → {step?.to_position}:{cards[step?.to_position]?.title}]</div>
                                            <div>{step?.comments === "" ? "-" : step?.comments}</div>
                                            <div>===============================================</div>
                                        </div>
                                    )
                                }
                            }
                        })
                    }
                </div>

            }

        </>
    )
}

export default GroupGameComments;